import { jsonp } from 'ThreeTerminal_base/base';
import { formatImage, formatUrl } from 'ThreeTerminal_base/publicMethod';

// apiUrl为webpack注入的全局变量
/* eslint-disable no-undef */
let apiBaseUrl = apiUrl;
/* eslint-enable no-undef */

if (typeof window !== 'undefined' && /\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/c';
}
const md5 = require('@ifeng/md5');
const createJsonpCallbackName = (str, num) => {
    num = num ? num : 0;
    let jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

    while (window[jsonpCallbackName]) {
        num++;
        jsonpCallbackName = `_${md5(`${str}_${num}`)}`;
    }

    return jsonpCallbackName;
};

// 获取分享二维码
export const getQrCode = async url => {
    return await jsonp(`//qrcode.ifeng.com/qrcode.php?url=${url}?_share=weixin`, {
        jsonpCallback: 'getQrCode',
        cache: false,
    });
};

// 获取轮播图数据
export const getSlidesData = async attachmentId => {
    const callback = createJsonpCallbackName('getSlidesData');

    const data = await jsonp(`${apiBaseUrl}/api/content/graphic/getSlides/${attachmentId}/${callback}`, {
        jsonpCallback: callback,
        cache: false,
    });

    let slidesData = null;

    if (data.data) {
        slidesData = {
            url: data.data.url,
            img:
                data.data.thumbnails && data.data.thumbnails.image && data.data.thumbnails.image[0]
                    ? formatImage(data.data.thumbnails.image[0].url, 349, 196)
                    : '',
            slideData: data.data.slideData ? JSON.parse(data.data.slideData).image : [],
        };
    }

    return slidesData;
};

// 获取文章评论数
export const getCommentCount = async url => {
    return await jsonp('//comment.ifeng.com/get.php', {
        data: {
            job: 1,
            format: 'js',
            docurl: url,
        },
        jsonpCallback: 'getCommentCount',
        cache: false,
    });
};

// 批量获取文章评论数
export const getCommentCounts = async docUrl => {
    let data = [];

    try {
        data = await jsonp('//comment.ifeng.com/get/multicount', {
            data: {
                doc_url: docUrl.join('|'),
                format: 'js',
            },
            jsonpCallback: 'getCommentCounts',
            cache: false,
        });
    } catch (e) {
        console.error(e);
    }

    return data;
};

// 获取文章推荐数
export const getVoteNum = async url => {
    let data = await jsonp('//survey.news.ifeng.com/api/getaccumulatorweight', {
        data: {
            format: 'js',
            key: url,
            serviceid: 2,
        },
        jsonpCallback: 'getaccumulator',
        cache: false,
    });
    const requestUrl = `//survey.news.ifeng.com/api/getaccumulatorweight?format=js&key=${url}&callback=getaccumulator`;

    const { schemaCheck } = require('./validate')
    data = schemaCheck(data.data, 'voteNumSchema', requestUrl);

    return data ? data : null;
};

// 文章推荐操作
export const vote = async url => {
    const data = await jsonp('//survey.news.ifeng.com/api/accumulator', {
        data: {
            format: 'js',
            key: url,
        },
        jsonpCallback: 'accumulator',
        cache: false,
    });

    return data.code === 1 && data.data && data.data.browse ? data.data.browse : 0;
};
